import React from 'react';
import { Box, Typography, Rating, useTheme } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { convertToCamelCase } from '@shared/helpers';

export const HotelHead = ({ detailsHotel, handleShowModal }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        mb: { xs: '24px', sm: '30px' },
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
        }}
      >
        <Typography
          align="justify"
          sx={{
            fontSize: { xs: '20px', sm: '30px' },
            fontWeight: 600,
            color: '#000',
            mr: detailsHotel.rating > 1 ? { sm: '2vw', xs: '5px' } : 0,
          }}
        >
          {detailsHotel.name}
        </Typography>

        {detailsHotel.rating > 1 && (
          <Rating
            value={Number.parseInt(detailsHotel.rating, 10)}
            max={5}
            readOnly
            sx={{
              mt: { xs: '5px', sm: '12px' },
            }}
          />
        )}
      </Box>

      <Typography
        onClick={handleShowModal}
        sx={{
          mt: '10px',
          display: 'inline-flex',
          alignItems: 'center',
          fontSize: { xs: '16px', sm: '18px' },
          color: theme.tertiary,
          cursor: 'pointer',
        }}
      >
        <LocationOnIcon
          sx={{ mr: '8px', color: theme.tertiary }}
          fontSize="small"
        />
        {convertToCamelCase(detailsHotel.location.address)}
      </Typography>
    </Box>
  );
};

export default HotelHead;
